<template>
    <div>
        <!-- Sidebar estilo IA -->
        <b-sidebar v-b-toggle.sidebar-no-header id="sidebar-ia" :visible.sync="showSidebar"
            :title="getTitleDrawer" shadow backdrop-variant="light" backdrop right class="ia-sidebar"
            :width="sidebarWidth" @hidden="onSidebarHidden">

            <!-- Contenido del sidebar -->
            <div>

                <!-- Procesador de archivos -->
                <FileProcessor
                    v-if="!parsedData"
                    @file-processed="onFileProcessed"
                    @processing-cancelled="onProcessingCancelled"
                    @create-without-fds="onCreateWithoutFDS"
                    :action="action"
                    :productId="productId"
                    :opcionGuardar="opcionGuardar"
                    :crearProductos="crearProductos"
                />

                <!-- Paso 2: mostrar datos detalles del documento -->
                <div v-else-if="parsedData && !showForm" class="p-3">

                    <!-- Progreso de la IA -->
                    <div class="p-3">
                        <ProcessingStep title="Documento cargado correctamente"
                            subtitle="Se ha extraído la información." icon="fa-file-pdf-o"
                            :isActive="false" :isCompleted="true" :useLoading="false" :useSlot="true">
                            <b-button variant="outline-info" @click="cancelAndReset">
                                    <i class="fa fa-times"></i>
                                    CANCELAR
                            </b-button>
                        </ProcessingStep>
                    </div>
                </div>

                <!-- Paso 3: mostrar datos del formulario -->
                <div v-else-if="parsedData && showForm" class="p-3">

                    <!-- Progreso de la IA -->
                    <div class="p-3">
                        <ProcessingStep title="Documento cargado correctamente"
                            subtitle="Se ha extraído la información." icon="fa-file-pdf-o"
                            :isActive="false" :isCompleted="true" :useLoading="false" :useSlot="true">
                            <b-button variant="outline-info" @click="cancelAndReset">
                                    <i class="fa fa-times"></i>
                                    CANCELAR
                            </b-button>
                        </ProcessingStep>
                    </div>

                    <!-- Formulario de producto -->
                    <div class="content-product" v-if="filter.company.id">
                        <h5 class="mb-3">
                            <i class="fa fa-product-hunt"></i>
                            Datos generales del producto
                        </h5>
                        <ProductForm
                            v-model="selectedProduct"
                            :action="'create'"
                            :estadoOptions="productStateOptions"
                            :currentManufacturer="null"
                            :productTypes="productTypeOptions"
                            :disabledInputs="false"
                            :showManufacturerActions="true"
                            :showCreateManufacturer="true"
                        />
                    </div>

                    <!-- Datos de destino (empresa/ubicación/campos personalizados) -->
                    <div class="content-details-company">

                        <h5 class="mb-3 mt-0">
                            <i class="fa fa-building"></i>
                            Datos de empresa, ubicación y campos personalizados
                        </h5>
                        <TargetContextForm />
                    </div>

                    <!-- Datos de lo que se creará (se mostrarán en el modal) -->
                    <div v-if="filter.company.id" class="px-3 mt-2">
                        <CreationSummary />
                    </div>

                    <!-- Botón para crear producto -->
                    <div v-if="filter.company.id" class="mx-3 d-flex justify-content-center">
                        <button class="mt-3 btn-ai" @click="onHandleStoreProduct">
                            <i class="fa fa-magic mr-2 fa-lg"></i>
                            CREAR PRODUCTO
                        </button>
                    </div>
                </div>
            </div>

            <br />
        </b-sidebar>
    </div>
</template>

<script>
// Vuex
import { mapActions, mapState, mapMutations } from "vuex";

// Componentes
import { ProductForm } from "../form";
import FileProcessor from "./components/FileProcessor.vue";
import ProcessingStep from "./components/ProcessingStep.vue";
import TargetContextForm from "./components/TargetContextForm.vue";
import CreationSummary from "./components/CreationSummary.vue";

// Helpers
import {
    setProductData,
    getParseDataSGA,
    getParseDataUN,
    getParseDataEPPS,
    getPayloadCreateProductWithIa
} from "@/servicios/productos/ia/helpers/ProcessDataProductHelper";

// ACL Helper
import { getAcls } from '@/plugins/acl';

// Mixins
import DrawerUpdateMixin from "@/servicios/productos/ia/mixins/drawer/update";

export default {
    name: "ProductAiSidebar",

    mixins: [
        DrawerUpdateMixin
    ],

    props: {
        action: {
            type: String,
            required: false,
            default: 'CREATE'
        },
        opcionGuardar: {
            type: Boolean,
            required: false,
            default: false
        },
        crearProductos: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        ProductForm,
        FileProcessor,
        ProcessingStep,
        TargetContextForm,
        CreationSummary
    },

    data() {
        return {
            showSidebar: false,
            parsedData: null,
            showForm: false,
            sidebarWidth: "800px",
            productId: null,
            product: this.getProductDefault(),
        };
    },

    mounted() {
        this.updateSidebarWidth();
        window.addEventListener("resize", this.updateSidebarWidth);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.updateSidebarWidth);
    },

    computed: {
        ...mapState('productos', ['customFields', 'selectedProduct', 'productStateOptions', 'productTypeOptions']),
        ...mapState("findings", ["filter"]),
        ...mapState('nuevocas', {
            components: 'componentesProducto'
        }),
        ...mapState('autenticacion', ['usuarioEmpresaContratista', 'usuarioAdmin']),

        getTitleDrawer() {
            return 'Asistente IA · ' + (this.action === 'CREATE' ? 'Crear' : 'Actualizar') + ' Producto';
        }

    },

    methods: {

        ...mapActions("accidents_high", ["getCompany"]),
        ...mapActions("productos", {
            storeProduct: 'guardaProducto',
            createProductWithIaProcess: 'createProductWithIaProcess'
        }),

        ...mapMutations('productos', {
            updateSelectedProduct: 'updateSelectedProduct',
            resetSelectedProduct: 'resetSelectedProducto'
        }),

        getProductDefault() {
            return {
                file: null,
                dateDocument: null,
                sga: [],
                un: {
                    class: [],
                    un: "NO REGULADO"
                },
                epps: {
                    "id_ocular": [],
                    "id_cutaneo": [],
                    "id_respiratorio": [],
                    "id_calzado": [],
                    "id_traje": []
                }
            }
        },

        /**
         * Actualiza el ancho del sidebar
         */
        updateSidebarWidth() {
            const newWidth = window.innerWidth <= 768 ? "100%" : "800px";
            this.sidebarWidth = newWidth;
        },

        /**
         * Maneja el evento de ocultación del sidebar
         */
        onSidebarHidden() {
            this.showSidebar = false;
            this.reset();
        },

        /**
         * Maneja el procesamiento completado del archivo
         */
        async onFileProcessed({ success, data, file }) {
            const response = data.response;
            this.parsedData = response;
            const baseDataProduct = { ...this.product,
                file: file,
                dateDocument: response['Fecha documento'],
                languageCode: response['Idioma'] || null,
                sga: getParseDataSGA(response),
                un: getParseDataUN(response),
                epps: getParseDataEPPS(response)
            }

            if (success) {
                // Actualizar el producto en el store con los datos de la API
                await setProductData({
                    response,
                    action: this.action
                });
                this.product = baseDataProduct
            }

            // Crear productos
            if (this.action === 'CREATE') {
                this.showForm = true;
            }

            // Actualizar productos
            if (this.action === 'UPDATE') {
                // Si usa CACHE, entonces primero se descomprime el Stringify
                const payload = response;
                this.onHandleUpdateProductWithIA(this.getDataCreateProductWithIa(payload));
            }
        },

        /**
         * Maneja la cancelación del procesamiento
         */
        onProcessingCancelled() {
            this.parsedData = null;
            this.resetSelectedProduct();
        },

        /**
         * Abre el drawer con el productId indicado (para UPDATE) o sin él (para CREATE).
         *
         * @param {Number|null} productId
         */
        open(productId = null) {
            this.reset();
            this.productId = productId;
            this.showSidebar = true;
        },

        reset() {
            this.parsedData = null;
            this.showForm = false;
            this.productId = null;
            this.resetSelectedProduct();

            // Reset campos de destino
            this.filter.company.id = null;
            this.filter.location_id = [];
            this.product = this.getProductDefault();
        },

        /**
         * Confirma la creación del producto
         */
        async onHandleStoreProduct() {
            const payload = this.getDataCreateProductWithIa();

            this.createProductWithIaProcess({
                params: payload,
                callback: this.callbackCreateProductWithIa
            });
        },

        getDataCreateProductWithIa(data = null) {
            return getPayloadCreateProductWithIa({
                action: this.action,
                product: { ...this.selectedProduct, id: this.productId, ...this.product, components: this.components },
                filter: this.filter,
                customFields: this.customFields,
                dataReadPdf: data
            });
        },

        callbackCreateProductWithIa(success, response) {
            if (!success) return

            this.$alertWithHtml('Asistente IA · Crear Producto',
                `<div><p>${response.message}</p></div>`,
                10000, true, 'success', true, 'Ver producto creado', '#3085d6', () => this.$router.push(`/productos/${response.data.product_id}`)
            );

            this.onSidebarHidden();
        },

        /**
         * Maneja cambios en campos personalizados
         */
        onFieldsChanged(val) {
            this.customFields = Array.isArray(val) ? val : [];
        },

        cancelAndReset() {
            this.parsedData = null;
            this.resetSelectedProduct();
            this.product = this.getProductDefault();
            this.showForm = false;
            this.filter.company.id = null;
            this.filter.location_id = [];
        },

        /**
         * Crear producto sin FDS (manual)
         */
        onCreateWithoutFDS() {
            this.showSidebar = false;

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.usuarioAdmin) {
                        this.$router.push('/productos-crear');
                    } else if (this.usuarioEmpresaContratista) {
                        this.$emit('open-manual-creation-modal');
                    }
                }, 300);
            });
        },

    },
};
</script>

<style scoped>
.ia-sidebar {
    font-family: "Inter", system-ui, sans-serif;
    width: var(--sidebar-width, 800px) !important;
}

.ia-sidebar .b-sidebar-header {
    font-weight: 600;
    font-size: 1.2rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.content-details-company {
    opacity: 1;
    background: linear-gradient(135deg, #f8f8f8 0%, #f8f8f8 100%);
    border-left: 4px solid #f8f8f8;
    padding: 15pt;
}

.content-product {
    opacity: 1;
    background: linear-gradient(135deg, #f8f8f8 0%, #f8f8f8 100%);
    border-left: 4px solid #f8f8f8;
    padding: 15pt;
}

/* Responsive para mobile */
@media (max-width: 768px) {
    .ia-sidebar {
        width: 100% !important;
    }
}

/* Botón base */
.btn-ai {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.9rem 4rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  color: #fff;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  border: 2px solid transparent;
  transition: transform 0.15s ease, box-shadow 0.3s ease;
  background: linear-gradient(90deg, #000, #20a8d8, #63c2de, #63c2de);

  transform: translateY(-2px);
  box-shadow: 0 8px 24px #20a7d8b7;
}

/* Efecto glow con gradiente animado */
.btn-ai::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  border-radius: 12px;
  background-size: 300% 300%;
  animation: ai-border 5s linear infinite;
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

/* Contenido del botón */
.btn-ai span {
  position: relative;
  z-index: 1;
}

/* Hover: leve zoom */
.btn-ai:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px #62c9eeb7;
}

/* Click: micro feedback */
.btn-ai:active {
  transform: scale(0.97);
}

/* Animación del gradiente */
@keyframes ai-border {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

</style>
